<template>
  <div class="app container-md">
    <div class="NavHeader">
      <NavHeader  :special-zone-list="specialZoneList" />
    </div>
    <div class="app_content" ref="app_content">
      <router-view></router-view>
<!--      <right-menu ></right-menu>-->
      <div class="NavFooter">
        <NavFooter  :special-zone-list="specialZoneList"/>
      </div>
    </div>
  </div>
</template>

<script>
import NavHeader from "@/views/procurementZone/components/NavHeader.vue";
import NavFooter from "@/views/procurementZone/components/NavFooter.vue";
// import rightMenu from "@@/components/rightMenu.vue";
import {getRegionYzApi} from "@/api/api";
import {getImgApi} from "@/api/public";

export default {
  components: {
    NavHeader,
    NavFooter,
    // rightMenu,
  },
  data() {
    return {
      specialZoneList: {},
      zoneId:''
    };
  },
  created(){
   this.init()
  },
  mounted() {
  },
  methods:{
    async init(){
      const {zoneId} = this.$route.query
      this.zoneId = zoneId
      const {data} = await getRegionYzApi({id :zoneId})
      this.specialZoneList = data
      if(data){
        const res = await getImgApi(data.regionLogo)
        let blob = new Blob([res], {type: 'image/png'})
        let herf = window.URL.createObjectURL(blob)
        var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = herf; // 图片放public目录
        document.getElementsByTagName('head')[0].appendChild(link);
        if(data.regionColour){
          // 动态设置主题色
          document.documentElement.style.setProperty('--theme-color', this.specialZoneList.regionColour)
        }
      }
    },

  },
  watch:{
    '$route':{
        immediate:true,
        handler(n){
            if(n.path=='/zone'){
                this.$router.push(`/zone/homeZone?zoneId=${this.zoneId}`)
            }
            sessionStorage.setItem('menu',n.path)
        }
    }
  },
};
</script>
<style scoped>
.app{
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  min-width: 1340px;
}
.NavHeader{
  height: 80px;
}
.app_content{
  height: calc(100% - 80px);
  overflow: hidden;
  overflow-y: auto;
  background-color: #F1F3F5;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  background-color: #f5f5f5;
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #c8c8c8;
}
:root{
  --theme-color: #F8901F;
}
</style>